import React from 'react';
import { Link } from 'react-router-dom';

const CTASection: React.FC = () => {
  return (
    <div className="bg-slate-800 dark:bg-slate-900 py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-lg bg-gradient-to-r from-primary-dark to-primary-main p-10 shadow-xl">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-white">Ready to start trading smarter?</h2>
            <p className="mt-4 text-lg text-white">
              Join thousands of successful traders who are already using our signals.
            </p>
            <div className="mt-8 flex justify-center">
              <Link
                to="./register"
                className="rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-primary-main shadow hover:bg-gray-100"
              >
                Sign Up Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
